import { render, staticRenderFns } from "./FormaCartao.vue?vue&type=template&id=749e5bb2&scoped=true&"
import script from "./FormaCartao.vue?vue&type=script&lang=js&"
export * from "./FormaCartao.vue?vue&type=script&lang=js&"
import style0 from "./FormaCartao.vue?vue&type=style&index=0&id=749e5bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749e5bb2",
  null
  
)

export default component.exports